import { GetCulpritAdjusterImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritAdjusterImagesTabs/getCulpritAdjusterImagesTabs.type';
import { getCulpritAdjusterImagesTabsQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritAdjusterImagesTabs/getCulpritAdjusterImagesTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritAdjusterImagesTabsOptions = (
  params: GetCulpritAdjusterImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_ADJUSTER_CULPRIT_IMAGE_TABS', params],
    queryFn: () => getCulpritAdjusterImagesTabsQueryFunction(params),
  });
};
